import { applyFieldLogic } from './apply-field-logic';
import { computeDefaults } from './compute-defaults';
import { getDynamicOptions } from './get-dynamic-options';
import { getFileNaming } from '../../utils/get-filenaming';
import { bulkOperations } from './bulk-operations';
import { buildFolder } from './build-folder';

export const getLogoVsLogoHelpers = () => ({
  applyFieldLogic,
  computeDefaults,
  getDynamicOptions,
  getFileNaming,
  bulkOperations,
  buildFolder
});
